<template>
  <div>
    <table class="table is-fullwidth is-hoverable is-size-7">
      <thead>
        <tr>
          <th>{{"messages.date" | translate}}</th>
          <th>{{"messages.address" | translate}}</th>
          <th>{{"messages.user" | translate}}</th>
          <th>{{"messages.messenger" | translate}}</th>
          <th>{{"messages.message" | translate}}</th>
          <th>{{"messages.status" | translate}}</th>
          <th>{{"messages.error" | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="message in messages">
          <td>{{message.date | datetime}}</td>
          <td>{{message.phoneNumber || message.email}}</td>
          <td>
            <router-link v-if="message.userId" :to="{ name: 'player', params: { playerId: message.userId } }" target="_blank">{{message.userId}}</router-link>
          </td>
          <td>{{message.messenger}}</td>
          <td>
            <b v-if="message.subject">{{message.subject}}</b>
            <p>{{message.message.length > 100 ? message.message.substr(0, 100) + '...' : message.message}}</p>
          </td>
          <td>
            <span class="tag is-success" :class="{'is-success': message.isSent, 'is-danger': !message.isSent}">{{`messages.is sent ${message.isSent}` | translate}}</span>
          </td>
          <td>{{message.errorMessage}}</td>
        </tr>
      </tbody>
    </table>
    <pagination @change="loadMessages();" ref="pagination" />
  </div>
</template>
<script>
  import messageService from '../../../services/message.service'

  import pagination from '../../common/pagination.vue'

  export default {
    name: 'messages-list',
    components: { pagination },
    data() {
      return {
        messages: [],
        newMessage: {
          text: null,
          phoneNumber: null,
          messenger: null
        },
        newMessageVisible: false
      }
    },
    async mounted() {
      await this.loadMessages();
    },
    methods: {
      async loadMessages() {
        const filter = {
          pageNumber: this.$refs.pagination.pageNumber,
          pageSize: this.$refs.pagination.pageSize
        };
        const data = await messageService.getByClient(filter);
        this.messages = data.items;
        this.$refs.pagination.set(data.pageNumber, data.totalPages);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/messages/index.vue